<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap align-left>
                <v-flex xs12 md12 xl3 class="pt-4">
                    <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
                </v-flex>
            </v-layout>
            <br />

            <chart :chartData="womenInCommitteesChartData" />

            <v-layout row wrap align-left>
                <v-flex xs12 sm6 md4 offset-xl3 xl3>
                   <v-text-field class="pr-2" style="padding-top: 27px !important;" v-if="!this.loading" v-model="committeeSearch" 
                    append-icon="search" label="Search" single-line hide-details></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 xl3>
                  <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                      label="Filter by committee types"
                      v-model="COMMITTEE_TYPES_SELECTED"
                      :items="COMMITTEE_TYPE_OPTIONS"
                      item-text="Filter"
                      item-value="Filter"
                      auto-select-first
                      multiple
                      clearable
                      small-chips
                      deletable-chips
                      v-on:change="FILTERBY_TYPE">
                       <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteCommitteeSelectionItem(item)" small close v-if="index == 0">{{item}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{COMMITTEE_TYPES_SELECTED.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
                <v-flex xs12 sm6 md4 xl3>
                  <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                      label="Select a Parliament"
                      v-model="SELECTED_PARLIAMENTS"
                      :items="this.$store.getters.GET_PARLIAMENTS_ORDERED_WOMENELECTED"
                      item-text="Name"
                      item-value="PID"
                      v-on:change="FILTERBY_PARLIAMENT"
                      :filter="FILTER_PARLIAMENT_OPTIONS"
                      auto-select-first
                      multiple
                      small-chips
                      clearable
                      deletable-chips>
                      <template
                        v-slot:prepend-item
                        v-if="this.$store.getters.GET_PARLIAMENTS.length > 0">
                        <v-list-tile
                          v-on:click="CLICK_CURRENTPARLIAMENT"
                          :value="currentParliamentValue"
                          ripple>
                          <v-list-tile-action>
                            <v-icon>{{ currentParliamentIcon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>Current Parliament</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </template>
                      <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteParliamentSelectionItem(item.Name)" small close v-if="index == 0">{{item.Name}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
               
            </v-layout>
            <br/>
            <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                        <v-subheader
                        >
                        Sort by:
                        </v-subheader>
                    <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <div class="stats-table"> 
            <v-data-table
                :headers="HEADERS"
                :items="DATATABLE_COMMITTEES"
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                :search="committeeSearch"
                v-on:update:pagination="UPDATE_PAGINATION"
                :hide-headers="isMobile"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                class="elevation-1"
            >
                <template v-slot:items="props">
                    <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_COMMITTEE, params: { CID: props.item.CID}}">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item pt-2">
                                    <h3 class="pb-xs-0">{{ props.item.Name }}</h3>
                                </div>
                                <div v-if="showParliaments" class="flex-item" data-label="Parliament">
                                    {{ props.item.ParliamentID }}
                                </div>
                                <div class="flex-item">
                                    <v-chip :class="props.item.Type.indexOf('General Purpose') > -1 ? 'ma-0 generalPurposeStanding' : 'ma-0'"
                                        small label :color="props.item.Type.startsWith('Senate')
                                            ? $store.state.COLOUR_SENATE
                                            : props.item.Type.startsWith('House')
                                            ? $store.state.COLOUR_REPRESENTATIVES
                                            : $store.state.COLOUR_JOINT">
                                        {{ props.item.Type }}
                                    </v-chip>
                                </div>
                                <div class="flex-item" data-label="Total members">
                                    {{ props.item.MemberCount }}
                                </div>
                                <div class="flex-item flex-item-col" data-label="Chair gender composition">
                                    {{ props.item.ChairCount == 0 ? "N/A" : ""}}
                                    <span v-if="props.item.ChairCount != 0">
                                        {{props.item.WomenChairPercentage}}% ({{props.item.WomenChairCount}}/{{props.item.ChairCount}})</span>
                                </div>
                                <div class="flex-item flex-item-col" data-label="Deputy Chair gender composition">
                                    {{ props.item.DeputyChairCount == 0 ? "N/A" : ""}}
                            
                                    <span v-if="props.item.DeputyChairCount != 0">
                                        {{props.item.WomenDeputyChairPercentage}}% ({{props.item.WomenDeputyChairCount}}/{{props.item.DeputyChairCount}})</span>
                                </div>
                                <div class="flex-item" data-label="Gender composition">
                                    {{ props.item.MemberCount == 0 ? "N/A" : ""}}
                            
                                <div v-if="props.item.MemberCount != 0" :data-sparkline="props.item.WomenCount + '; ' + ( props.item.MemberCount - props.item.WomenCount)"></div>
                                <span v-if="props.item.MemberCount != 0" style="margin-top: -7px;">
                                    {{props.item.WomenPercentage}}% women ({{props.item.WomenCount}}/{{props.item.MemberCount}})</span>
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else
                        class="tr"
                        :to="{
                        name: $store.state.ROUTE_COMMITTEE,
                        params: { CID: props.item.CID},
                        }"
                    >
                        <td class="text-xs-left">
                            <v-chip :class="props.item.Type.indexOf('General Purpose') > -1 ? 'generalPurposeStanding' : ''"
                                small label
                                :color="props.item.Type.startsWith('Senate')
                                    ? $store.state.COLOUR_SENATE
                                    : props.item.Type.startsWith('House')
                                    ? $store.state.COLOUR_REPRESENTATIVES
                                    : $store.state.COLOUR_JOINT">
                                {{ props.item.Type }}
                            </v-chip>
                        </td>
                     
                        <td class="text-xs-left" v-if="showParliaments">{{ props.item.ParliamentID }}</td>
                        <td class="text-xs-left">{{ props.item.Name }}</td>
                       
                       <td class="text-xs-left" style="width:80px">
                            {{ props.item.MemberCount }}
                        </td>
                        <td class="text-xs-left" >
                            {{ props.item.ChairCount == 0 ? "N/A" : ""}}
                            
                             <span v-if="props.item.ChairCount != 0">
                                 {{props.item.WomenChairPercentage}}% ({{props.item.WomenChairCount}}/{{props.item.ChairCount}})</span>
                        </td>
                        <td class="text-xs-left" >
                            {{ props.item.DeputyChairCount == 0 ? "N/A" : ""}}
                            
                             <span v-if="props.item.DeputyChairCount != 0">
                                 {{props.item.WomenDeputyChairPercentage}}% ({{props.item.WomenDeputyChairCount}}/{{props.item.DeputyChairCount}})</span>
                        </td>
                         
                        <td class="text-xs-left">
                            {{ props.item.MemberCount == 0 ? "N/A" : ""}}
                            
                            <div v-if="props.item.MemberCount != 0" :data-sparkline="props.item.WomenCount + '; ' + ( props.item.MemberCount - props.item.WomenCount)"></div>
                            <span v-if="props.item.MemberCount != 0" style="float:right; margin-top: -7px;">
                                {{props.item.WomenPercentage}}% women ({{props.item.WomenCount}}/{{props.item.MemberCount}})</span>
                        </td>
                        
                    </router-link>
                </template>
                <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            Your search for "{{ committeeSearch }}" found no results.
                        </v-alert>
                    </template>
            </v-data-table>
            </div>
                   <br />
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import Chart from './Chart.vue';
import axios from 'axios';
import Highcharts from 'highcharts';
import _ from 'lodash';

window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
  
    components: {
        Loader,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
        Chart
    },
    methods: {
        deleteCommitteeSelectionItem(item) {
            this.COMMITTEE_TYPES_SELECTED = this.COMMITTEE_TYPES_SELECTED.filter(find => find !== item);
            this.FILTERBY_TYPE(this.COMMITTEE_TYPES_SELECTED);
        },
        deleteParliamentSelectionItem(item) {
            this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find.Name !== item.Name);
            this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
        },
        initialiseItems() {
            this.loading = true;

            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];

            const committeeTypes = this.COMMITTEE_TYPES_SELECTED.filter(s => s.indexOf("All types") == -1).join(",")

            const url = `StatisticalInformation/NumberOfWomenInParliament?parliamentariantype=${parliamentarianType}&committeeTypes=${committeeTypes}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data.Rows;
                    this.parties = response.data.Parties;
                    this.partiesExcludingTotal = response.data.Parties.filter(p => p.Party !== 'Total');
                    this.headers = [{
                        text: 'Date',
                        value: 'Date'
                    }, ...response.data.Parties.map(p => ({ text: p.Party, value: p.PartyId || p.Party }))]
                    this.loading = false;
                });

            const parentCommitteesURL = `StatisticalInformation/ParentCommittees`;
            axios.get(`api/${parentCommitteesURL}`)
                .then(response => {
                    this.committeeData = response.data;
                    this.committeeData = response.data;
                   
                   

                     if (!this.showParliaments){
                         this.DATATABLE_COMMITTEES = this.committeeData;
                        this.FILTER_COMMITTEES();
                        this.$nextTick(() => {
                            this.doChunk();
                        });
                     }
                });
    
            const committeesURL = `StatisticalInformation/CommitteesByParliamentStatistics`;
            axios.get(`api/${committeesURL}`)
                .then(response => {
                    this.committeeDataByParliament =  response.data;
                    if (this.showParliaments){
                        this.DATATABLE_COMMITTEES = this.committeeDataByParliament;
                         this.FILTER_COMMITTEES();
                          this.$nextTick(() => {
                            this.doChunk();
                        });
                    }
                });
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        UPDATE_PAGINATION: function (options) {
            this.$gtag.event("committees by name pagination items per page", {
                event_category: "filters",
                event_label: `items per page: ${options.rowsPerPage}`,
                value: 1,
            });
            this.$gtag.event("committees by name pagination page", {
                event_category: "filters",
                event_label: `page: ${options.page}`,
                value: 1,
            });
            this.$gtag.event(`committees by name sorting`, {
                event_category: "sorting",
                event_label: `sort by ${options.sortBy} ${
                options.descending ? "DESC" : "ASC"
                }`,
                value: 1,
            });
            this.$nextTick(() => {
                this.doChunk();
            });
            return this.PAGINATION;
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items
                .map(i => ({ Date: new Date(i.Date).toLocaleDateString(), ...i.Parties.reduce((ac,a) => ({...ac,[a.Party]: a.WomenCount }),{}) }));
            let headers = this.headers.map(h => h.text);
            const filename = this.title;
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        FILTERBY_TYPE: function (types) {
            //No types, add all
            if (types.length == 0) {
                this.COMMITTEE_TYPES_SELECTED.push("All types");
            } else {
                //Went from no items (on load) to multiple. Remove 'All types'
                if (
                this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0 &&
                this.COMMITTEE_TYPES_SELECTED.length > 1 &&
                this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1
                ) {
                this.COMMITTEE_TYPES_SELECTED.splice(
                    this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
                    1
                );
                }
                //Previous list didn't have all types, now we are adding it, allow this to happen
                else if (
                this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1 &&
                (this.COMMITTEE_TYPES_SELECTED_PREVIOUS.indexOf("All types") == -1 ||
                    this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0)
                ) {
                this.COMMITTEE_TYPES_SELECTED = ["All types"];
                }
                //In all other cases, remove 'all types' if user has selected other options
                else if (this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1) {
                this.COMMITTEE_TYPES_SELECTED.splice(
                    this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
                    1
                );
                }
            }

            this.COMMITTEE_TYPES_SELECTED_PREVIOUS = types;
            return this.FILTER_COMMITTEES();
        },
        FILTERBY_PARLIAMENT: function (parliaments) {
            this.$gtag.event("committees by parliament parliament filter", {
                event_category: "filters",
                event_label: `parliaments selected: ${
                parliaments.length > 0 ? parliaments.join(",") : "none"
                }`,
                value: 1,
            });
            return this.FILTER_COMMITTEES();
        },
        FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
            const pId = item.PID;
            const name = item.Name.toLowerCase();
            const searchText = queryText.toLowerCase();
            return (
                name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1
            );
        },
        CLICK_CURRENTPARLIAMENT: function () {
            this.$nextTick(() => {
                let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                            let currentParliament = parliaments[0].PID;
                            if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                                let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                                if (index > -1) {
                                    this.SELECTED_PARLIAMENTS.splice(index, 1);
                                }
                            } else {
                                this.SELECTED_PARLIAMENTS.push(currentParliament);
                            }
                this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
            });
        },
        FILTER_COMMITTEES: function () {
            this.HEADERS = this.ParentCommittee_HEADERS;
            this.showParliaments = false;
            // create a function scoped var to hold all Committees
            let OBJ_records = this.committeeData;
            let OBJ_types = [];
            let index = 0;

            var currentObjRecords = [];
            if (this.SELECTED_PARLIAMENTS.length == 0){
                OBJ_records = this.committeeData;
            }

            for (index = 0; index < this.SELECTED_PARLIAMENTS.length; ++index) {
                var internalRecords = this.committeeDataByParliament;
                this.HEADERS = this.PointInTimeCommittee_HEADERS;
                   this.showParliaments = true;

                //  FILTERS_SELECTED_PARLIAMENTS
                var parliament = this.$store.getters.GET_PARLIAMENT_BYPID(
                    parseInt(this.SELECTED_PARLIAMENTS[index])
                );
                if (!parliament) {
                    continue;
                }

                var filtered = internalRecords
                    .filter((Obj) => Obj.ParliamentID == parliament.PID);

                currentObjRecords = currentObjRecords.concat(filtered);
            }

            OBJ_records = currentObjRecords;

            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                if (OBJ_records.length === 0) {
                    OBJ_records = this.committeeData;
                }

                var showAll = false;

                for (index = 0; index < this.COMMITTEE_TYPES_SELECTED.length; ++index) {
                    var txtVal = this.COMMITTEE_TYPES_SELECTED[index].replace(
                        " of Representatives",
                        ""
                    );
                    if (txtVal == "All types") {
                        showAll = true;
                    }
                    OBJ_types = OBJ_types.concat(
                        OBJ_records.filter((Obj) => Obj.Type === txtVal)
                    );
                }

                if (showAll) {
                    OBJ_types = OBJ_records;
                }
            }

            const recordsResult = OBJ_types;

            let query = this.$router.query || {};

            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                query.committeeTypes = this.COMMITTEE_TYPES_SELECTED.join(",");
            }

            if (this.SELECTED_PARLIAMENTS.length > 0) {
                query.parliaments = this.SELECTED_PARLIAMENTS.join(",");
            }
            
            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                this.DATATABLE_COMMITTEES = this._.sortBy(
                    recordsResult,
                    "CommitteeName"
                );
            } else {
                this.DATATABLE_COMMITTEES = [];
            }

            if (Object.keys(query).length > 0) {
                history.replaceState(
                {},
                null,
                this.$route.path +
                    "?" +
                    Object.keys(query)
                    .map((key) => {
                        return key + "=" + query[key];
                    })
                    .join("&")
                );
            } else {
                history.replaceState({}, null, this.$route.path);
            }

            this.$nextTick(() => {
                this.doChunk();
            });

            

            return true;
        },
        SparkLine (a, b, c) {
            var hasRenderToArg = typeof a === 'string' || a.nodeName;
            var options = arguments[hasRenderToArg ? 1 : 0];
            var defaultOptions = {
                exporting: {
                    enabled: false
                },
                chart: {
                    renderTo: (options.chart && options.chart.renderTo) || this,
                    backgroundColor: null,
                    borderWidth: 0,
                    type: 'bar',
                    margin: [2, 0, 2, 0],
                    height: 30,
                    skipClone: true
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                yAxis: {
                    endOnTick: false,
                    startOnTick: false,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    tickPositions: [0]
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    hideDelay: 0,
                    outside: true,
                },
                plotOptions: {
                    bar: {
                        stacking: 'percent',
                    },
                    series: {
                        animation: false,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            radius: 1,
                            states: {
                                hover: {
                                    radius: 2
                                }
                            }
                        },
                        fillOpacity: 0.25
                    },
                    column: {
                        negativeColor: '#910000',
                        borderColor: 'silver'
                    }
                }
            };

            options = Highcharts.merge(defaultOptions, options);

            return hasRenderToArg ? new Highcharts.Chart(a, options, c) : new Highcharts.Chart(options, b);
        },
        doChunk() {
            this.tds = document.querySelectorAll('div[data-sparkline]');
            var i, j, len = this.tds.length, $td, stringdata, arr, series, chart;
    
            for (i = 0; i < len; i += 1) {
                $td = this.tds[i];
                stringdata = $td.dataset.sparkline;
             
                arr = stringdata.split('; ');
                series = [];

                var showChart = false;

                for(j = 0; j < arr.length; j++) {
                    if (arr[0] != 0 ||  arr[1] != 0){
                        showChart = true;
                    }
                    series.push({
                        data: 
                        [{ 
                            total: arr[0] + arr[1], 
                            name: j == 0 ? 'Women' : 'Men', 
                            y: parseInt(arr[j].replace(' ', ''))
                        }],
                    });
                }

                chart = {};

                if (showChart){
                    this.SparkLine(
                        $td,
                        {
                            series: series,
                            tooltip: {
                                headerFormat: '<span style="font-size: 10px">Gender composition:</span><br/>',
                                pointFormat: '{point.percentage:.2f}% {point.name} ({point.y}/{point.total})'
                            },
                            chart: chart
                        }
                    );
                }
                
                this.n += 1;
            }
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
    }, 
    computed: {
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            currentParliamentIcon: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                let currentParliament = parlArray[0].PID;
                if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                    return '$vuetify.icons.checkboxOn';
                } else {
                    return '$vuetify.icons.checkboxOff';
                }
            },
            currentParliamentValue: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS;
                if (
                    this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)
                ) {
                    return parlArray[parlArray.length - 1].PID;
                } else {
                    return false;
                }
            },
            womenInCommitteesChartData() {
                const series = [ 'Women in Parliament', 'Women in committees', 'Women chairs/deputy chairs']
                    .map(h => ({
                    name: h,
                    data: []
                }));

                const categories = [];
                var data = this.items;
                var maxYAxisVal = 0;

                data.forEach(d => {
                    if ((this.SELECTED_PARLIAMENTS.length == 0 || this.SELECTED_PARLIAMENTS.indexOf(d.Parliament) > -1) && d.Parliament > 15){
                        categories.push(d.Parliament);
                        const female = series[0];
                        female.color = '#434348';
                        const womenCommittees = series[1];
                        womenCommittees.color = '#38a9d9';
                        const womenChairs = series[2];
                        womenChairs.color = '#38d953';
                        const total = d.Parties.find(p => p.Party === 'Total');
                        female.data.push(total.WomenCount);
                        womenCommittees.data.push(total.WomenInCommitteesCount);
                        womenChairs.data.push(total.WomenInChairsCount);
                        
                        if (maxYAxisVal < total.WomenCount){
                            maxYAxisVal = total.WomenCount;
                        }
                    }
                });

                return {
                    chart: {
                        type: 'line',
                        height: 500,
                    },
                    title: {
                        text: "Women's service on committees over time"
                    },
                    accessibility: {
                        point: {
                            valueDescriptionFormat: '{index}. {point.category}, {point.y:,.0f}.'
                        }
                    },
                    xAxis: {
                        categories: categories,
                        tickmarkPlacement: 'on',
                        title: {
                            enabled: false
                        },
                         plotLines: this.SELECTED_PARLIAMENTS.length == 0  ? [{
                            color: '#ddd',
                            width: 2,
                            value: 1
                        }] : [],
                    },
                    yAxis: {
                        labels: {
                            formatter: function () {
                                return this.value;
                            }
                        },
                        title: {
                            enabled: false
                        }
                    },
                    exporting: {
                        filename: "Women's service on committees over time",
                        sourceWidth: 1200
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: ({point.y:,.0f})<br/>',
                        split: true,
                    },
                    plotOptions: {
                        area: {
                            lineColor: '#ffffff',
                            lineWidth: 1,
                            marker: {
                                lineWidth: 1,
                                lineColor: '#ffffff'
                            }
                        }
                    },
                    annotations: [{
                        labels: this.SELECTED_PARLIAMENTS.length == 0  ? [
                        {
                            point: {
                                x: 1,
                                xAxis:0,
                                y: 0,
                                yAxis: maxYAxisVal/2
                            },
                            align: 'left',
                            allowOverlap: true,
                            text: 'First women elected<br>to Parliament<br>21/08/1943'
                        }] : [],
                        draggable: '',
                        zIndex: 999,
                        labelOptions: {
                            backgroundColor: 'rgba(255,255,255,0.5)',
                            borderColor: 'silver'
                        }
                    }],
                    series
                }
            },
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
            this.FILTER_COMMITTEES();
        },
        COMMITTEE_TYPES_SELECTED: function () {
            this.initialiseItems();
            this.FILTER_COMMITTEES();
        }
    },
    mounted() {
        this.onResize();
        if (this.$route.query.committeeTypes) {
            this.COMMITTEE_TYPES_SELECTED = this.$route.query.committeeTypes
                .split(",")
                .map((p) => p.replace("%20", ""));
        } 
        else {
            this.COMMITTEE_TYPES_SELECTED = ["All types"];
        }

        if (this.$route.query.parliaments) {
            this.SELECTED_PARLIAMENTS = this.$route.query.parliaments
                .split(",")
                .map((p) => parseInt(p));
            if (this.SELECTED_PARLIAMENTS.length > 0){
                this.showParliaments = true;
            }
        }

        this.FILTER_COMMITTEES();
    },
    data() {
        return {
        title: 'Women in committees',
        showParliaments: false,
        isMobile: false,
        headers: [],
        items: [],
        stats: [],
        PARLIAMENTS: this.$store.getters.GET_PARLIAMENTS,
        SELECTED_PARLIAMENTS: [],
        womenPartyItems: [],
        womenCommitteeItems: [],
        womenCommitteeParties: [],
        parties: [],
        chartType: 'womenInCommittees',
        partiesExcludingTotal: [],
        committees: [],
        currentParliament: 0,
        DATATABLE_COMMITTEES: [],
        committeeDataByParliament: [],
        committeeData: [],
        committeeSearch: "",
        loading: true,
        COMMITTEE_TYPE_OPTIONS: [
            "All types",
            "House of Representatives Select",
            "House of Representatives Standing",
            "Senate Estimates",
            "Senate Legislative and General Purpose Standing",
            "Senate Select",
            "Senate Standing",
            "Joint Select",
            "Joint Standing",
            "Joint Statutory",
        ],
        COMMITTEE_TYPES_SELECTED: [],
        COMMITTEE_TYPES_SELECTED_PREVIOUS: [],
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        ROWS_LISTITEMS: [
            10,
            20,
            50,
            100,
            {
            text: "$vuetify.dataIterator.rowsPerPageAll",
            value: -1,
            },
        ],
        PAGINATION: {
            rowsPerPage: 50,
            sortBy: "WomenPercentage",
            descending: true
        },
        ParentCommittee_HEADERS: [
        {
          text: "Committee type",
          value: "CommitteeType",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Committee name",
          value: "Name",
          align: "left",
          sortable: true,
          model: this.committeeName,
        },
       {
          text: "Total members",
          value: "MemberCount",
          align: "left",
          sortable: true,
          width: "50px",
        },
         {
          text: "Chair gender composition",
          value: "WomenChairPercentage",
          align: "left",
          sortable: true,
            width: "100px",
        },
        {
          text: "Deputy Chair gender composition",
          value: "WomenDeputyChairPercentage",
          align: "left",
          sortable: true,
            width: "100px",
        },
        
        {
          text: "Gender composition",
          value: "WomenPercentage",
          align: "left",
          sortable: true,
           width: "250px",
        },
        
        
        ],
        PointInTimeCommittee_HEADERS: [
        {
          text: "Committee type",
          value: "CommitteeType",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Parliament",
          value: "ParliamentID",
          align: "left",
          sortable: true,
           width: "100px",
        },
         {
          text: "Committee name",
          value: "Name",
          align: "left",
          sortable: true,
        },
         {
          text: "Total members",
          value: "MemberCount",
          align: "left",
          sortable: true,
          width: "50px",
        },
        {
          text: "Chair gender composition",
          value: "WomenChairPercentage",
          align: "left",
          sortable: true,
            width: "100px",
        },
        {
          text: "Deputy Chair gender composition",
          value: "WomenDeputyChairPercentage",
          align: "left",
          sortable: true,
            width: "100px",
        },
        
        {
          text: "Gender composition",
          value: "WomenPercentage",
          align: "left",
          sortable: true,
           width: "250px",
        },
       
      ],
      HEADERS: []
      
    }
}
}
</script>
<style lang="stylus" scoped>
    .generalPurposeStanding {
        height: 35px !important;
        line-height: 14px;
    }

    .generalPurposeStanding >>> .v-chip__content {
        width: 180px !important;
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: normal;
    }

    @media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }
</style>